module.exports = __webpack_public_path__ + "img/carousel-1.17dd8534.png";